import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { SupabaseMergeTagService } from "../../merge-tag/server/supabase-merge-tag-service";

import type { Tags } from "../../merge-tag/types";

export function useMergeTags(): ReturnType<typeof useSupabaseLoader<Tags>> {
  return useSupabaseLoader(
    async ({ supabase }) => new SupabaseMergeTagService(supabase).getAllMergeTags(),
    [],
  );
}
